import React, { useState } from 'react';
import { Modal, Button, Form, Input } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { sendWhatsApp } from 'Redux/actions/sendWhatsAppAction';

export function success() {
  const content = 'Cotización enviada con éxito';
  Modal.success({
    content,
  });
}

export function error(response) {
  let content = 'Ocurrio un error al enviar la cotización';
  if (response.status_code === 404) {
    const errors = response.errors.whatsapp;
    content = `Se han enviado con éxito la cotización a los telefonos: ${errors.success.toString()}\n\nOcurrio un error al enviar la cotización a los telefonos: ${errors.fail.toString()}`;
  }
  Modal.error({
    content,
  });
}

const modalSendWhatsApp = (props) => {
  const {
    visible, handleCancel, title, label, placeholder, sendWhatsAppProps, idQuotation, isLoading,
  } = props;
  const [form] = Form.useForm();
  const [stateWhatsApp, setStateWhatsApp] = useState({ whatsAppsIsValid: false, whatsAppsErros: [] });
  // const [isLoading, setLoading] = useState(false);

  const onSubmit = async () => {
    // validate emails
    const values = await form.validateFields();

    const phones = values.phones.split(',');

    const whatsAppsErros = phones.filter((phone) => phone.length)
      .map((phone) => {
        if (phone.length) {
          const phoneRegex = /^(\(\+57\)){0,1}(\+57){0,1}[0-9]{10}$/g; // Numeros con +57 o (+57) de 10 digitos
          return {
            phone,
            isValid: phoneRegex.test(phone),
          };
        }
        return { phone: '', isValif: false };
      });

    let phonesIsvalid = true;
    for (let phone in whatsAppsErros) {
      phonesIsvalid = whatsAppsErros[phone].isValid && phonesIsvalid;
    };

    setStateWhatsApp({ whatsAppsIsValid: phonesIsvalid, whatsAppsErros });

    // invok callback
    if (phonesIsvalid) {
      // handleOk(emails)
      sendWhatsAppProps({ phones, idQuotation }).then((response) => {
        success(response);
        handleCancel();
      }).catch((response) => {
        error(response);
        handleCancel();
      });
    }
  };

  const handleOnchangePhones = (e) => {
    const phonesValues = e.target.value;
    const newPhones = phonesValues.replace(/ /g, ',');
    form.setFieldsValue({ phones: newPhones });
  };

  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={handleCancel}
      maskClosable={false}
      footer={[
        <Button key="back" onClick={handleCancel}>Cerrar</Button>,
        <Button key="submit" type="primary" loading={isLoading} onClick={onSubmit} >Enviar</Button>,
      ]}
    >
      <Form
        layout="vertical"
        form={form}>
        <Form.Item
          rules={[{ required: true, message: 'Telefono/telefonos es requerido' }]}
          style={{ marginBottom: 0 }}
          name="phones"
          label={label}>
          <Input onChange={handleOnchangePhones} type="text" placeholder={placeholder} />
        </Form.Item>

      </Form>
      {
        stateWhatsApp.whatsAppsErros.filter((phone) => !phone.isValid)
          .map((item, key) => {
            return <div key={key}><span style={{ color: 'red', fontSize: 13 }}>Telefono no válido {item.phone}</span></div>;
          })
      }
    </Modal>
  );
};

modalSendWhatsApp.propTypes = {
  visible: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func,
  title: PropTypes.any.isRequired,
  label: PropTypes.any.isRequired,
  placeholder: PropTypes.any.isRequired,
  sendWhatsAppProps: PropTypes.any.isRequired,
  idQuotation: PropTypes.any,
  isLoading: PropTypes.any.isRequired,
};

const actions = {
  sendWhatsAppProps: sendWhatsApp,
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.sendWhatsAppQuotation.requestState.isFeching,
  };
};
export default connect(mapStateToProps, actions)(modalSendWhatsApp);
